<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="footer">
    <div class="footer_top">
      <div class="footer_left">
        <div class="left_head">
          <img
            class="img"
            src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/logo1.png"
            alt=""
          />
        </div>
        <div class="left_foot">
          <div
            class="item"
            @click="jump(item.src)"
            v-for="(item, index) in images"
            :key="index"
          >
            <img v-if="item.src != ''" class="img" :src="item.img" alt="" />
            <el-popover
              v-if="item.src == '' && index == 1"
              placement="top"
              trigger="click"
              popper-class="popover"
            >
              <div
                class="custom-content"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img
                  class="img1"
                  src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/ks_img.jpg"
                  alt=""
                  style="width: 100px"
                />
              </div>
              <img class="img" :src="item.img" alt="" slot="reference" />
            </el-popover>
            <el-popover
              v-if="item.src == '' && index == 2"
              placement="top"
              trigger="click"
              popper-class="popover"
            >
              <div
                class="custom-content"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img
                  class="img1"
                  src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/xhs_img.jpg"
                  alt=""
                  style="width: 100px"
                />
              </div>
              <img class="img" :src="item.img" alt="" slot="reference" />
            </el-popover>
            <el-popover
              v-if="item.src == '' && index == 3"
              placement="top"
              trigger="click"
              popper-class="popover"
            >
              <div class="custom-content">
                <img
                  class="img1"
                  src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/sph.jpg"
                  alt=""
                  style="width: 100px"
                />
                <img
                  class="img1 img2"
                  src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/sph1.jpg"
                  alt=""
                  style="width: 100px; margin-left: 10px"
                />
              </div>
              <img class="img" :src="item.img" alt="" slot="reference" />
            </el-popover>
          </div>
        </div>
      </div>
      <div class="footer_right">
        <div class="right_item right_item1">
          <img
            class="img"
            src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/gzh.png"
            alt=""
          />
          <div class="text">微信公众号</div>
        </div>
        <div class="right_item">
          <img
            class="img"
            src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/kf.png"
            alt=""
          />
          <div class="text">微信客服</div>
        </div>
      </div>
    </div>
    <div class="footer_bottom">
      <div class="text" @click="jumpPage(0)">隐私政策</div>
      <div class="shu"></div>
      <div class="text" @click="jumpPage(1)">使用条款</div>
    </div>
    <footer class="footer-beian">
      <p class="text">© 2025 杭州二白智能科技有限公司</p>
      <p>
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          style="color: #777; text-decoration: none"
          >浙ICP备20005457号-4</a
        >
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        {
          name: "抖音",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/dy.png",
          http: "",
          src: "https://www.douyin.com/user/MS4wLjABAAAANcdwoOeTTwylonOhdDobFeDX7CDLOhYpCiA2MaKf3Q4?from_tab_name=main",
        },
        {
          name: "快手",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/ks.png",
          http: "",
          src: "",
        },
        {
          name: "小红书",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/xhs.png",
          http: "",
          src: "",
        },
        {
          name: "视频号",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/sp.png",
          http: "",
          src: "",
        },
        {
          name: "微博",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/wb.png",
          http: "",
          src: "https://weibo.com/u/6657374642",
        },
        {
          name: "哔哩哔哩",
          img: "https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/bilibili.png",
          http: "",
          src: "https://space.bilibili.com/362785416?spm_id_from=333.337.0.0",
        },
      ],
    }
  },
  methods: {
    jump(url) {
      if (url != "") {
        window.open(url, "_blank")
      }
    },
    jumpPage(e) {
      if (e == 0) {
        if (this.$route.path != "/mobile/privacy") {
          this.$router.push("/mobile/privacy")
        }
      } else {
        if (this.$route.path != "/mobile/terms") {
          this.$router.push("/mobile/terms")
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  .footer_top {
    width: 100%;
    box-sizing: border-box;
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    background-color: #121212;
    padding: 20px;
    .footer_left {
      margin-bottom: 40px;
      .left_head {
        display: flex;
        align-items: center;
        .img {
          width: 100px;
          height: 30px;
        }
      }
      .left_foot {
        display: grid;
        grid-column-gap: 10px;
        grid-template-rows: auto;
        grid-template-columns: repeat(6, 1fr);
        margin-top: 20px;
        .item {
          width: 40px;
          height: 40px;
          border-radius: 100px;
          background-color: #2a2a2a;
          display: flex;
          align-items: center;
          justify-content: center;
          .img {
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
          ::v-deep .el-popover .custom-content {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            .img1 {
              width: 200px !important;
              height: 300px !important;
            }
            .img2 {
              margin-left: 20px !important;
            }
          }
        }
        .item:nth-child(3) {
          background-color: #404040;
          .img {
            width: 24px;
            height: 10px;
          }
        }
      }
    }
    .footer_right {
      display: flex;
      align-items: center;
      justify-content: center;
      .right_item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .img {
          width: 100px;
          height: 100px;
          border-radius: 10px;
          margin-bottom: 15px;
        }
        .text {
          font-size: 0.875rem;
          color: #888888;
        }
      }
      .right_item1 {
        margin-right: 50px;
      }
    }
  }
  .footer_bottom {
    width: 100%;
    background-color: #171717;
    padding: 15px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .text {
      font-size: 0.875rem;
      color: #666666;
      cursor: pointer;
    }
    .shu {
      width: 1px;
      height: 15px;
      background-color: #4f4f4f;
      margin: 0 24px;
    }
  }
    .footer-beian {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #777;
    background-color: #171717;
    font-size: .75rem;
    .text {
      margin-right: 10px;
    }
    a {
      color: #555;
      text-decoration: none;
    }
    a:hover {
      text-decoration: underline;
    }
  }
}
</style>
